module.exports = __webpack_public_path__ + "static/media/cat-space.526b35a9.svg";